<ng-container *ngIf="formControl">
  <div class="date-with-spinner-info-container">
    <div class="date-with-spinner-info-container__info">
      <div
        class="date-with-spinner-info-container__info__spinner-container"
        [ngStyle]="{ 'width.px': widthOfInput + 33 }"
        *ngIf="formControl.status === 'PENDING' && widthOfInput"
      >
        <span class="spinner spinner-sm spinner-inverse"> </span>
      </div>

      <div class="date-with-spinner-info-container__info__lag" *ngIf="info">
        <span class="lag">
          {{ info }}
        </span>
      </div>
    </div>
    <clr-date-container
      [ngClass]="{
        'date-input__readonly': readOnly
      }"
    >
      <input
        #dateInput
        type="date"
        clrDate
        [placeholder]="formControl.status === 'PENDING' ? ' ' : 'DD MMM YYYY'"
        [inputValidator]="inputValidatorKey"
        [required]="required"
        [id]="id"
        [readonly]="readOnly"
        [formControl]="formControl"
        [readOnly]="formControl.status === 'PENDING' || readOnly"
        [min]="minDate"
        [title]="title"
        [fieldName]="formControlName"
        (focus)="onDateInputFocus()"
        [ngStyle]="{
          color: textColor
        }"
        (clrDateChange)="onClrDateChange($event)"
        (change)="onInputChange($event)"
        (blur)="onElemBlur()"
        (focus)="onElemFocus()"
      />
    </clr-date-container>
  </div>
</ng-container>
